/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacationRequestsScopeFilter } from './vacationRequestsScopeFilter';


export interface VacationRequestsIncludeFilterItems { 
    relation?: VacationRequestsIncludeFilterItems.RelationEnum;
    scope?: VacationRequestsScopeFilter;
}
export namespace VacationRequestsIncludeFilterItems {
    export type RelationEnum = 'user' | 'approverBoss' | 'payrollApprover' | 'manualApprover' | 'rejectedBy';
    export const RelationEnum = {
        User: 'user' as RelationEnum,
        ApproverBoss: 'approverBoss' as RelationEnum,
        PayrollApprover: 'payrollApprover' as RelationEnum,
        ManualApprover: 'manualApprover' as RelationEnum,
        RejectedBy: 'rejectedBy' as RelationEnum
    };
}


